import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { TypographyConfig } from '@vds-core/typography';
var propTypes = {
  children: PropTypes.string.isRequired,

  /**
   * @ignore
   */
  label: PropTypes.string,

  /**
   * @ignore
   */
  target: PropTypes.oneOf(['', '_blank', '_self', '_parent', '_top']),

  /**
   * @ignore
   */
  url: PropTypes.string,

  /**
   * @ignore
   */
  href: PropTypes.string,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  colorConfig: PropTypes.object
};
var defaultProps = {
  target: '_self',
  className: null
};
/*
fontWeightStrong represents the font weight found in 
typography used when the component is bolded. Font weight is
not exported by typography configs due to the fact that 
typography components may have multiple font weight options
*/

var StyledBreadcrumbAnchor = /*#__PURE__*/styled.a.withConfig({
  displayName: "StyledBreadcrumbAnchor",
  componentId: "sc-htyi4p-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-decoration: none;\n  transition: color 0.15s ease-out;\n  cursor: pointer;\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: 400;\n  line-height: ", ";\n  color: ", ";\n  text-decoration: none;\n  &:focus {\n    outline: ", ";\n    outline-offset: 2px;\n  }\n"])), function (_ref) {
  var bodySmall = _ref.bodySmall;
  return bodySmall.fontFamily;
}, function (_ref2) {
  var bodySmall = _ref2.bodySmall;
  return calculateRem(bodySmall.fontSize);
}, function (_ref3) {
  var bodySmall = _ref3.bodySmall;
  return calculateRem(bodySmall.lineHeight);
}, function (_ref4) {
  var colors = _ref4.colors;
  return colors.coolGray6;
}, function (_ref5) {
  var focusState = _ref5.focusState;
  return focusState ? '1px dashed' : '-webkit-focus-ring-color auto 5px;';
});
/**
 * @ignore
 */

var BreadcrumbAnchor = function BreadcrumbAnchor(props) {
  var label = props.label,
      url = props.url,
      href = props.href,
      target = props.target,
      children = props.children,
      className = props.className,
      bodyConfig = props.bodyConfig,
      focusState = props.focusState,
      typescale = props.typescale,
      colorConfig = props.colorConfig,
      ariaLabel = props.ariaLabel,
      analyticsTrack = props['data-analyticstrack'],
      track = props['data-track'],
      clickStream = props['data-clickstream'],
      cta = props.cta,
      level = props.level,
      position = props.position,
      dataTrack = props.dataTrack;

  function _onClick(e) {
    if (e.type === 'click') {
      e.currentTarget.blur();
    }
  }

  function _onMouseDown(e) {
    e.preventDefault();
  }

  var bodySmall = bodyConfig.getStyles(typescale, 'desktop', 'small');
  return /*#__PURE__*/React.createElement(StyledBreadcrumbAnchor, {
    onMouseDown: _onMouseDown,
    focusState: focusState,
    bodySmall: bodySmall,
    href: href || url,
    target: target,
    "aria-label": ariaLabel ? ariaLabel : label,
    role: "link",
    className: className,
    tabIndex: 0,
    onClick: _onClick,
    colors: colorConfig,
    "data-analyticstrack": analyticsTrack,
    "data-track": track,
    "data-clickstream": clickStream,
    "data-sitecat-datatrack": dataTrack,
    "data-sitecat-position": position,
    "data-sitecat-level": level,
    "data-sitecat-cta": cta
  }, children);
};

BreadcrumbAnchor.propTypes = propTypes;
BreadcrumbAnchor.defaultProps = defaultProps;
export default BreadcrumbAnchor;